module.exports = __webpack_public_path__ + "img/private-house.1f04a994.svg";